import { TipoRecorrenciaInterface } from "../../../../Interfaces/Geral/GestaoDeCadastro/TipoRecorrencia/TipoRecorrenciaInterface";

import {
    CadastratarTipoRecorrenciaService,
    DeletarTipoRecorrenciaService,
    EditarTipoRecorrenciaService,
    ListarTipoRecorrenciaService,
} from "../../../../Services/Geral/GestaoDeCadastros/TipoRecorrencia/TipoRecorrenciaService";
import { Controller } from "../../../Controller";

//TipoRecorrencia
export async function ListarTipoRecorrenciaController() {
    return Controller(ListarTipoRecorrenciaService());
}

export async function CadastratarTipoRecorrenciaController(
    requestBody: TipoRecorrenciaInterface
) {
    return Controller(CadastratarTipoRecorrenciaService(requestBody));
}

export async function EditarTipoRecorrenciaController(
    requestBody: TipoRecorrenciaInterface
) {
    return Controller(EditarTipoRecorrenciaService(requestBody));
}

export async function DeletarTipoRecorrenciaController(
    IDTipoDocumento: number
) {
    return Controller(DeletarTipoRecorrenciaService(IDTipoDocumento));
}
